import { image } from '../../../../utils/data/baseUrl';
import {
  FRIENDS,
  SHOP as SHOP_STATE,
  SHELF as SHELF_STATE,
  MAIN,
  SETS,
  // YEAR_STAT,
} from '../../../../constants/shared/states/names';
import { stores /* defaultContur, conturs */ } from '../../../../translations';
import { BOXES, PREM, SHELF, SHOP /*, TREE*/ } from './actions';
import { ONBOARDING_MODALS } from './modals';
import { goldAppleLink } from '../../../../constants/copyright';

export default {
  onboardingModals: {
    [SHELF]: {
      modalType: ONBOARDING_MODALS.FAVORITE_SHELF,
      position: { x: 0.5, y: 0.75 },
      text: 'onboardingModals.favoriteShelfOnboarding2026.text',
      title: 'onboardingModals.favoriteShelfOnboarding2026.title',
    },
    [BOXES]: {
      modalType: ONBOARDING_MODALS.BEAUTY_BOXES,
      position: { x: 0.5, y: 0.75 },
      text: 'onboardingModals.beautyBoxesOnboarding2026.text',
      title: 'onboardingModals.beautyBoxesOnboarding2026.title',
    },
    [SHOP]: {
      modalType: ONBOARDING_MODALS.SHOP,
      position: { x: 0.5, y: 0.75 },
      text: 'onboardingModals.shopOnboarding2026.text',
      title: 'onboardingModals.shopOnboarding2026.title',
    },
    [PREM]: {
      modalType: ONBOARDING_MODALS.PREMIUM,
      position: { x: 0.5, y: 0.25 },
      text: 'onboardingModals.premiumOnboarding2026.text',
      title: 'onboardingModals.premiumOnboarding2026.title',
    },
    // [TREE]: {
    //   modalType: ONBOARDING_MODALS.TREE,
    //   position: { x: 0.5, y: 0.25 },
    //   text: 'onboardingModals.treeOnboarding2025.text',
    //   title: 'onboardingModals.treeOnboarding2025.title',
    //   buttonText: 'onboardingModals.treeOnboarding2025.buttonText',
    //   isFly: false,
    // },
  },
  VICHIAndLaRochePosayModal: {
    subtitle: 'brands.VICHIAndLaRochePosay',
    img: image('brands/laRoche.png'),
    selectionTitle: 'other.selection.products',
    isBack: true,
    buttons: [
      {
        attr: {
          text: 'other.toShop',
          link: 'https://goldapple.ru/brands/la-roche-posay?utm_source=spetsproekt&utm_medium=tamagotchi&utm_campaign=sa_ga_spetsproekt_tamagotchi_game_brand_zone',
        },
      },
    ],
  },
  items: [
    {
      availableStores: [stores.ru, stores.kz, stores.ae],
      action: SHOP,
      img: image('interactiveShop/items/shop.png'),
      shadow: image('interactiveShop/items/shop-shadow.png'),
      modal: ONBOARDING_MODALS.SHOP,
      className: 'interactive-shop__item-button',
      button: {
        timeout: 1000,
        modalData: { action: 'close', data: { type: 'current' } },
        redirect: SHOP_STATE,
        gtm: 'GTMShopItem',
        gtmProps: 'hanger',
      },
    },
    {
      availableStores: [stores.ru, stores.kz, stores.ae],
      action: PREM,
      img: image('interactiveShop/items/prem.png'),
      shadow: image('interactiveShop/items/prem-shadow.png'),
      modal: ONBOARDING_MODALS.PREMIUM,
      className: 'interactive-shop__item-button',
      button: {
        timeout: 1000,
        modalData: { action: ['close', 'open'], data: { close: { type: 'current' }, open: { type: 'passModal' } } },
        gtm: 'GTMShopItem',
        gtmProps: 'blue_star',
      },
    },
    {
      availableStores: [stores.ru, stores.kz, stores.ae],
      action: SHELF,
      img: image('interactiveShop/items/shelf.png'),
      shadow: image('interactiveShop/items/shelf-shadow.png'),
      modal: ONBOARDING_MODALS.FAVORITE_SHELF,
      className: 'interactive-shop__item-button',
      button: {
        timeout: 1000,
        modalData: { action: 'close', data: { type: 'current' } },
        redirect: SHELF_STATE,
        gtm: 'GTMShopItem',
        gtmProps: 'beauty_product',
      },
    },
    {
      availableStores: [stores.ru, stores.kz, stores.ae],
      action: BOXES,
      img: image('interactiveShop/items/boxes.png'),
      shadow: image('interactiveShop/items/boxes-shadow.png'),
      modal: ONBOARDING_MODALS.BEAUTY_BOXES,
      className: 'interactive-shop__item-button',
      button: {
        timeout: 1000,
        modalData: { action: 'close', data: { type: 'current' } },
        redirect: SETS,
        gtm: 'GTMShopItem',
        gtmProps: 'box',
      },
    },
    // {
    //   availableStores: [stores.ru, stores.kz],
    //   action: TREE,
    //   img: image('interactiveShop/items/tree.png'),
    //   shadow: image('interactiveShop/items/tree-shadow.png'),
    //   modal: ONBOARDING_MODALS.TREE,
    //   className: 'interactive-shop__item-button',
    //   button: {
    //     timeout: 1000,
    //     modalData: { action: 'close', data: { type: 'current' } },
    //     redirect: YEAR_STAT,
    //   },
    // },
  ],
  buttons: {
    toFriends: {
      className: 'main__button button_friends button_transparent',
      icon: 'buttons/person',
      gtm: 'GTMFriends',
      redirect: FRIENDS,
    },
    toBack: {
      className: 'button_bathroom',
      icon: 'buttons/to-main-2',
      redirect: MAIN,
    },
  },
  statusPanel: {
    type: 'shop',
  },
  images: {
    tableLight: {
      className: 'interactive-shop__table-light',
      src: image('interactiveShop/other/interactive-shop-table-light.png'),
    },
    table: {
      className: 'interactive-shop__table',
      src: image('interactiveShop/other/interactive-shop-table.png'),
    },
    background: {
      className: 'interactive-shop__background-image',
    },
  },
  /*treeSequence: {
    length: 2,
    imgProps: {
      className: 'interactive-shop__tree-sequence',
    },
    settings: {
      duration: 0.5,
      ease: 'sine.inOut',
    },
  },*/
};
